// extracted by mini-css-extract-plugin
export default {"statsGrid":"UserStatsGrid_statsGrid__-Xee1","leetcode":"UserStatsGrid_leetcode__gfbSN","grid":"UserStatsGrid_grid__FB+k9","card":"UserStatsGrid_card__KLSVX"};